import React from 'react';
import ReactMarkdown from 'react-markdown';
import classNames from 'classnames';
import results from '../../data/results';

function formatValue(type, data) {
  if (type == "number") {
    const number = data.value;
    return number == null ? "-" : `${Math.round(number)}ms`;
  }

  return data.value ? "YES" : "NO";
}

function classFor(criteria, data) {
  if (criteria && data.value === null) {
    return "is-number is-nominal";
  }

  if (criteria && criteria[1] < data.value) {
    return "is-number is-critical";
  } else if (criteria && criteria[0] < data.value) {
    return "is-number is-warning";
  } else if (criteria && criteria[0] >= data.value) {
    return "is-number is-good";
  }

  return data.value ? "is-word is-good" : "is-word is-critical";
}

const StatsItem = (props) => {
  const {stat, comparison, target, isMobile} = props;
  const result = results[stat.name];
  if (result == null) { return null; }

  if (isMobile) {
    const className =
      "results__stats-list__item " +
      (target == "them" ? classFor(result.criteria, stat.data) : "is-good");
    return <li className={className}>
      <div className="is-label">{result.label}</div>
      <div className="is-value">{formatValue(result.type, target == "them" ? stat.data : state.estimate)}</div>
    </li>
  }

  return <tr>
    <td>
      <div className="is-info">
        <span className="is-anchor"><span>View Info</span></span>
        <div className="is-tooltip">
          <ReactMarkdown source={result.text} />
          {result.extra && <div><p>See <a href={result.extra.link} target="_blank">{result.extra.text}</a> for more information.</p></div>}
        </div>
      </div>
      <span className="is-label">{result.label}</span>
    </td>
    <td><div className={classFor(result.criteria, stat.data)}>{formatValue(result.type, stat.data)}</div></td>
    {comparison && <td className="is-us"><div className={`${result.type === "number" ? "is-number" : "is-word"} is-good`}>
      {formatValue(result.type, stat.estimate)}
    </div></td>}
  </tr>;
};

StatsItem.propTypes = {
  stat: React.PropTypes.object,
  comparison: React.PropTypes.bool
};

export default StatsItem;



// WEBPACK FOOTER //
// ./src/components/results/StatsItem.js